import { render, staticRenderFns } from "./TeamProfileInformation.vue?vue&type=template&id=97cf8f22&scoped=true&"
import script from "./TeamProfileInformation.vue?vue&type=script&lang=js&"
export * from "./TeamProfileInformation.vue?vue&type=script&lang=js&"
import style0 from "./TeamProfileInformation.vue?vue&type=style&index=0&id=97cf8f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cf8f22",
  null
  
)

export default component.exports